import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { AppointmentData } from '@/types';

const baseURL = import.meta.env.VITE_API_URL;

export const checkAvailability = createAsyncThunk(
    'appointment/checkAvailability',
    async (
        data: { inmate_info: string; visit_hour: string; visit_day: string },
        thunkAPI
    ) => {
        try {
            const response = await axios.post(`${baseURL}/api/prison/appointment-available-time`, data);
            return response.data;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const bookAppointment = createAsyncThunk(
    'appointment/bookAppointment',
    async (data: AppointmentData, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${baseURL}/api/book-appointment`, data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.message || 'Failed to book appointment');
        }
    }
);

export const checkTimeSlot = createAsyncThunk(
    'appointment/checkTimeSlot',
    async (data: AppointmentData, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${baseURL}/api/appointment/available-slots`, data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.message || 'Failed to book appointment');
        }
    }
);

interface AppointmentState {
    loading: boolean;
    error: string | null;
    success: boolean;
    appointmentId: string | null;
    availability: any;
    slots:any
}

const initialState: AppointmentState = {
    loading: false,
    error: null,
    success: false,
    appointmentId: null,
    availability: null,
    slots: []
};

const appointmentSlice = createSlice({
    name: 'appointment',
    initialState,
    reducers: {
        resetAppointmentState: (state) => {
            state.loading = false;
            state.error = null;
            state.success = false;
            state.appointmentId = null;
            state.availability = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(checkAvailability.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.availability = null;
            })
            .addCase(checkAvailability.fulfilled, (state, action) => {
                console.log('CHECK AVAILABILITY ===>>>>', action);
                state.loading = false;
                state.availability = action.payload;
            })
            .addCase(checkAvailability.rejected, (state, action) => {
                state.loading = false;
                state.error = (action.payload as string) || 'Something went wrong';
            })
            .addCase(bookAppointment.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(bookAppointment.fulfilled, (state, action: any) => {
                state.loading = false;
                state.success = action.payload?.message;
                state.appointmentId = action.payload?.appointmentId;
            })
            .addCase(bookAppointment.rejected, (state, action) => {
                state.loading = false;
                state.error = (action.payload as string) || 'Something went wrong';
            })
            .addCase(checkTimeSlot.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(checkTimeSlot.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.slots = action.payload?.data;

            })
            .addCase(checkTimeSlot.rejected, (state, action: any) => {
                state.loading = false;
                state.error = (action.payload as string) || 'Something went wrong';
            });
    },
});

export const { resetAppointmentState } = appointmentSlice.actions;
export default appointmentSlice.reducer;
